const ethnicityOptions = [
    { text: 'Black', value: 'Black' },
    { text: 'White', value: 'White' },
    { text: 'Asian', value: 'Asian' },
    { text: 'Hispanic', value: 'Hispanic' }
];
export default ethnicityOptions;